<template>
	<div :class="['management_wrap', currentRoute]">
		<TitleComponent
			v-if="this.currentRoute !== 'management-login'"
		></TitleComponent>
		<SelectorComponent
			v-if="
				this.currentRoute !== 'management-login' &&
				this.currentRoute !== 'merchant-management' &&
				this.currentRoute !== 'setup' &&
				this.currentRoute !== 'setup-notice' &&
				this.currentRoute !== 'setup-faq' &&
				this.currentRoute !== 'setup-cs'
			"
		></SelectorComponent>

		<router-view></router-view>
	</div>
</template>

<script>
import TitleComponent from '@/components/Management/TitleComponent';
import SelectorComponent from '@/components/Management/SelectorComponent';
import '@/assets/css/management.css';
export default {
	name: 'ManagementLayout',
	components: {
		TitleComponent,
		SelectorComponent,
	},
	data() {
		return {
			// scrollPosition: 0,
			// isScroll: false,
		};
	},
	computed: {
		currentRoute() {
			return this.$route.name;
		},
	},
	methods: {
		// updateScroll() {
		// 	this.scrollPosition = window.scrollY;
		// 	this.isScroll = this.scrollPosition > 64;
		// },
	},
	mounted() {
		// window.addEventListener('scroll', this.updateScroll);
	},
};
</script>

<style scoped></style>
